
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'shadow-md' : ''
    }`} style={{ backgroundColor: '#0D1B2A' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/eaf2641b549e7c9c1f20a608bd7edb5f.png" 
              alt="متجر" 
              className="h-16 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-base font-medium text-white hover:text-[#D4A84B] transition-colors whitespace-nowrap cursor-pointer">
              الرئيسية
            </Link>
            <Link to="/products" className="text-base font-medium text-white hover:text-[#D4A84B] transition-colors whitespace-nowrap cursor-pointer">
              المنتجات
            </Link>
            <Link to="/categories" className="text-base font-medium text-white hover:text-[#D4A84B] transition-colors whitespace-nowrap cursor-pointer">
              الفئات
            </Link>
            <Link to="/about" className="text-base font-medium text-white hover:text-[#D4A84B] transition-colors whitespace-nowrap cursor-pointer">
              من نحن
            </Link>
            <Link to="/contact" className="text-base font-medium text-white hover:text-[#D4A84B] transition-colors whitespace-nowrap cursor-pointer">
              اتصل بنا
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <Link to="/checkout" className="relative cursor-pointer">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-shopping-cart-line text-2xl" style={{ color: '#C49D49' }}></i>
              </div>
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full" style={{ backgroundColor: '#C49D49' }}>
                  {cartCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
